<template>
  <div class="CancelReservations CommonContentSingle-gray">

    <el-header style="background: rgba(255, 255, 255, 1);max-height: 206px;min-height: 100px;height: auto;">
        <el-form ref="form" label-width="80px" style="margin: 20px 0px;background: rgba(255, 255, 255, 1);padding: 10px;overflow: hidden;height: 42px;">
          <el-form-item :label="$t('original.languages110')" style="float: left">
            <el-input v-model="formInline.Synthetical"  :placeholder="$t('original.languages254')" ></el-input>
          </el-form-item>
          <el-form-item :label="$t('original.Name_of_Company')" style="float: left">
            <el-input v-model="formInline.Unit" :placeholder="$t('original.languages4')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('original.languages345')" style="float: left">
            <el-date-picker type="daterange" value-format="yyyy-MM-dd" v-model="formInline.ConsultPaperTime" :range-separator="$t('original.languages296')" :start-placeholder="$t('original.languages346')" :end-placeholder="$t('original.languages347')" unlink-panels >
            </el-date-picker>
          </el-form-item>
          <el-form-item class="cvbb" style="float: left">
            <el-button type="primary" @click="screening">{{ $t('original.screening') }}</el-button>
            <el-button type="primary" @click="resetForm('formInline')">{{ $t('original.reset') }}</el-button>
          </el-form-item>
        </el-form>
      </el-header>
    <el-container>
      
      <el-main style="margin-top: 15px; background-color: rgba(255, 255, 255, 1)">
        <el-row>
          
          <el-table v-loading="wloadings" :data="tableData" style="width: 100%">

            <el-table-column :label="$t('original.The_serial_number')" align="left" min-width="6%">
              <template slot-scope="scope" center>
                {{ (formInline.pageIndex - 1) * 10 + scope.$index + 1 }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages79')" min-width="10%">
              <template slot-scope="scope">
                <span>{{ scope.row.UserID }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.name')" min-width="10%">
              <template slot-scope="scope">
                <span>{{ scope.row.UserName }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.gender')" min-width="6%">
              <template slot-scope="scope">
                <span>{{ scope.row.Sex }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages256')" min-width="6%">
              <template slot-scope="scope">
                <span>{{ scope.row.Birthday }}</span>
              </template>
            </el-table-column>
            
            <el-table-column :label="$t('original.Name_of_Company')" min-width="20%">
              <template slot-scope="scope">
                <span>{{ scope.row.DeptName }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages310')" min-width="6%">
              <template slot-scope="scope">
                <span>{{ scope.row.Used }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages44')" min-width="10%">
              <template slot-scope="scope">
                <span>{{ scope.row.ConsultPaperTime }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages477')" min-width="10%">
              <template slot-scope="scope">
                <span>{{ scope.row.TermYear }}</span>
              </template>
            </el-table-column>

            <el-table-column :label="$t('original.languages49')" min-width="10%">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">{{ $t('original.languages49') }}</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="block">
            <el-pagination style="margin-top: 20px; text-align: right; margin-bottom: 10px" @current-change="handleCurrentChange" :current-page.sync="currentPage1" :page-size="10" layout="total, prev, pager, next" :total="Counts"></el-pagination>
          </div>

        </el-row>
      </el-main>
    </el-container>

    <el-drawer :visible.sync="drawer" :with-header="false">
      <h2>{{ $t('original.languages357') }}</h2>
      <h6>{{ $t('original.languages358') }}</h6>
      <ul class="block_ul">
        <li>
          <p><span>{{ $t('original.name') }}：</span>{{ Name }}</p>
        </li>
        <li>
          <p><span>{{ $t('original.gender') }}：</span>{{ Sex }}</p>
        </li>
        <li>
          <p><span>{{ $t('original.languages256') }}：</span>{{ BirthdayTi }}</p>
        </li>
        <li>
          <p><span>{{ $t('original.Date_of_birth') }}：</span>{{ Birthday }}</p>
        </li>
        <li>
          <p><span>{{ $t('original.languages359') }}：</span>{{ MarriageState }}</p>
        </li>
        <li>
          <p><span>{{ $t('original.phone') }}：</span>{{ Phone }}</p>
        </li>
      </ul>
      <h6 style="padding-top: 10px">{{ $t('original.languages360') }}</h6>
      <ul class="block_ul">
        <li>
          <p><span>{{ $t('original.name') }}：</span>{{ EmergentPerson }}</p>
        </li>
        <li>
          <p><span>{{ $t('original.phone') }}：</span>{{ EmergentMobile }}</p>
        </li>
        <li>
          <p><span>{{ $t('original.languages361') }}：</span>{{ EmergentRelation }}</p>
        </li>
      </ul>
      <h5 style="padding-top: 10px">{{ $t('original.languages362') }}</h5>

      <el-table v-loading="wloadings" :data="tableData2" style="width: 100%">
        <el-table-column :label="$t('original.The_serial_number')" align="left" min-width="6%">
          <template slot-scope="scope" center>
            {{ (formInline.pageIndex - 1) * 10 + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('original.languages225')" min-width="10%">
          <template slot-scope="scope">
            <span>{{ scope.row.ZuName }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('original.languages208')" min-width="15%">
          <template slot-scope="scope">
            <span>{{ scope.row.ConsultTheme }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('original.languages272')" min-width="10%">
          <template slot-scope="scope">
            <span>{{ scope.row.ConsultSchTime }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('original.languages363')" min-width="10%">
          <template slot-scope="scope">
            <span>{{ scope.row.ConsultPaperTime }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="!hcsuih" :label="$t('original.languages190')" min-width="10%">
          <template slot-scope="scope">
            <span v-if="scope.row.States == -1">{{ "-" }}</span>
            <span style="color: rgba(255, 193, 23, 1)"  v-else-if="scope.row.States == 0" >{{ $t('original.languages489') }}</span>
            <span style="color: rgba(21, 191, 109, 1)" v-else-if="scope.row.States == 1" >{{ $t('original.languages203') }}</span>
            <span style="color: rgba(242, 75, 78, 1)" v-else-if="scope.row.States == 2" >{{ $t('original.languages204') }}</span>
            <span style="color: rgba(242, 75, 78, 1)" v-else-if="scope.row.States == 3" >{{ $t('original.languages488') }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('original.languages49')" min-width="12%" align="center">
          <template slot-scope="scope">

            <div v-if="hcsuih">
              <el-button @click="handleCheckRecord(scope.row)" type="text" size="small">{{$t('original.languages174')}}</el-button>
            </div>

            <div v-else>



              <el-button v-if="scope.row.States == 1 || scope.row.States == -1" @click="handleCheckRecord(scope.row)"  type="text" size="small">{{$t('original.languages174')}}</el-button>

              <el-button v-if="scope.row.States == 0 || scope.row.States == 1" type="text" size="small" disabled>{{$t('original.languages364')}}</el-button>
              <el-button v-else  @click="Toapply(scope.row)" type="text" size="small">{{$t('original.languages364')}}</el-button>
            </div>

      
            
          </template>
        </el-table-column>
      </el-table>
    </el-drawer>

    <el-dialog :title="$t('original.languages365')" :visible.sync="dialogVisible" width="400px" :before-close="handleClose">
      <el-input  type="textarea" :placeholder="$t('original.languages366')" v-model="fromdata.ApplyReason"  resize="none"  style="width:100%;height:80px;"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('original.cancel') }}</el-button>
        <el-button type="primary" @click="determine">{{ $t('original.languages59') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="WPPdialogVisible2" width="80%" :before-close="handleClose">
      <div class="filein">
        <div class="filein-top">
          <p class="filein-top-p1">
            <span>
              {{ wonedata.UserName }}(<span>来访者</span>)
              <i>{{ wonedata.Status }}</i>
            </span>
          </p>
          <el-form style="margin:0 20px">
            <el-form-item style="margin: 0">
              <el-row>
                <el-col :span="6">咨询方式：{{ wonedata.ConsultType }}</el-col>
                <el-col :span="6">咨询地点：{{ wonedata.ZXDZ}}</el-col>
                <el-col :span="6">联系方式：{{ wonedata.Phone}}</el-col>
                <el-col :span="6">预约时间：{{ wonedata.Yuyue}}</el-col>
              </el-row>
            </el-form-item>
            <el-form-item style="margin: 0">
              <el-row>
                <el-col :span="6">婚姻状态：{{wonedata.MarriageState}}</el-col>
                <el-col :span="6">性别：{{ wonedata.Sex }}</el-col>
                <el-col :span="6">年龄：{{ new Date().getFullYear() - new Date(wonedata.Birthday).getFullYear() }}</el-col>
                <el-col :span="6">咨询时间：{{ wonedata.ConsultTime}}</el-col>
              </el-row>
            </el-form-item>
            <el-form-item style="margin: 0">
              <el-row>
                <el-col :span="6">剩余次数：{{wonedata.ResidueCount}}</el-col>
                <el-col :span="6">所属院系所：{{wonedata.DeptName}}</el-col>
                <el-col :span="6">目前年级：{{wonedata.EntryDate}}</el-col>
              </el-row>
            </el-form-item>
          </el-form>
         <!-- <el-button @click="wexport">导出报告</el-button> -->
        </div>
        <div class="filein-button">
          <h2>个人情况</h2>
          <h3>知情同意</h3>
          <el-form :inline="true" :model="from" ref="from" label-width="100px" class="demo-ruleForm">
            <el-form-item disabled="true" label-width="276px" label="保密原则告知和解释（书面和口头）" prop="AnswerName1">
              <span style="margin-left:20px">{{ wonedata2.AnswerName1 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="234px" label="知情同意讨论（书面和口头）" prop="AnswerName2">
              <span style="margin-left:20px">{{ wonedata2.AnswerName2 }}</span>
            </el-form-item>

            <el-form-item class="hiucs" label="备注" label-width="80px" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName3 }}</span>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px; font-size: 18px; font-weight: 700;">
                <p>来访者问题主诉</p>
              </div>
            </el-form-item>

            <el-form-item label-width="80px" style="width: 100%;">
              <p style="margin-left: 20px;"> {{ wonedata2.QuestionName4 }}<span>{{ wonedata2.AnswerName4 }}</span>来寻求咨询帮助
              </p>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px; font-size: 18px; font-weight: 700;">
                <p>
                  相关健康史
                  <span>（重大疾病史）</span>
                </p>
              </div>
            </el-form-item>

            <el-form-item label-width="120px" style="margin-left: 20px;">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName7 }}
              </span>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px; font-size: 18px; font-weight: 700;">
                <p>个人成长史</p>
              </div>
            </el-form-item>

            <el-form-item label-width="40px" style="width: 100%; border: none !important;">
              <h2 style="font-size: 14px;">创伤史</h2>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="重大丧失" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName8 }}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName8 == '是'" disabled="true" label-width="120px" label="重大丧失说明" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName8Detail }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="暴力侵害" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName9 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName9 == '是'" disabled="true" label-width="120px" label="暴力侵害说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName9Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="性侵害" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName10 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName10 == '是'" disabled="true" label-width="120px" label="性侵害说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName10Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="被忽视" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName11 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName11 == '是'" disabled="true" label-width="120px" label="被忽视说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName11Detail }}
              </span>
            </el-form-item>

            <el-form-item class="hiucs" label="备注" label-width="80px" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName12 }}</span>
            </el-form-item>
            <br/>
            <!-- <el-form-item label-width="40px" style="width: 100%; border: none !important;">
              <h2 style="font-size: 14px;">家族史11111</h2>
            </el-form-item> -->

            <el-form-item disabled="true" label-width="120px" label="家族史" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName13A }}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName13A == '是'" disabled="true" label-width="120px" label="父亲" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName13A_1}}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName13A == '是'" disabled="true" label-width="120px" label="母亲" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName13A_2}}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName13A == '是'" disabled="true" label-width="120px" label="祖父" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName13A_3 }}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName13A == '是'" disabled="true" label-width="120px" label="外祖父" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName13A_4}}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName13A == '是'" disabled="true" label-width="120px" label="祖母" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName13A_5}}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName13A == '是'" disabled="true" label-width="120px" label="外祖母" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName13A_6 }}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName13A == '是'" disabled="true" label-width="120px" label="其他" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName13A_7 }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="精神病史" prop="UserID" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName13 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName13 == '是'" disabled="true" label-width="120px" label="精神病史说明" prop="UserID">
                <span style="margin-left:20px">
                  {{ wonedata2.AnswerName13Detail }}
                </span>
              </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="自杀自伤" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName14 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName14 == '是'" disabled="true" label-width="120px" label="自杀自伤说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName14Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="130px" label="暴力攻击倾向" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName16 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName16 == '是'" disabled="true" label-width="150px" label="暴力攻击倾向说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName16Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="酒精滥用" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName17 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName17 == '是'" disabled="true" label-width="120px" label="酒精滥用说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName17Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="物质滥用" prop="UserID" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName18 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName18 == '是'" disabled="true" label-width="120px" label="物质滥用说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName18Detail }}
              </span>
            </el-form-item>

            <el-form-item class="hiucs" label="备注" label-width="80px" style="width: 100%;">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName19 }}
              </span>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px;">
                <p style="font-size: 18px; font-weight: 700;">状态评估</p>
              </div>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px;">
                <p style="font-size: 14px;">危机评估</p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="自我伤害风险" prop="AnswerName4"
              style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName20 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="伤害他人危机"
              style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName29 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="146px" label="自我照料危机" prop="UserID" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName37 }}</span>
            </el-form-item>

            <el-form-item style="width: 100%; border: none !important;">
              <div class="tit" style="margin-left: 20px;">
                <p style="font-size: 14px;">保护因素</p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──咨询/求助动机" prop="AnswerName5">
              <span style="margin-left:20px">{{ wonedata2.AnswerName21 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──家庭支持" prop="AnswerName6">
              <span style="margin-left:20px">{{ wonedata2.AnswerName22 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──社会支持" prop="AnswerName7">
              <span style="margin-left:20px">{{ wonedata2.AnswerName23 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──问题解决能力">
              <span style="margin-left:20px">{{ wonedata2.AnswerName24 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──活下去的希望" prop="AnswerName9">
              <span style="margin-left:20px">{{ wonedata2.AnswerName25 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──积极的宗教信仰" prop="AnswerName10">
              <span style="margin-left:20px">{{ wonedata2.AnswerName26 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="342px" label="保护因素评估──不想让有些/某个重要人物失望 " prop="AnswerName11"
              style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName27 }}</span>
            </el-form-item>

            <el-form-item class="hiucs" label="保护因素评估──其他相关因素" label-width="240px" style="width: 100%;">
              <span >{{ wonedata2.AnswerName28 }}</span>
            </el-form-item>

            <!-- <el-form-item disabled="true" label-width="260px" label="保护因素评估──咨询/求助动机" prop="AnswerName14">
              <span style="margin-left:20px">{{ wonedata2.AnswerName30 }}</span>
            </el-form-item> -->

            <!-- <el-form-item disabled="true" label-width="260px" label="保护因素评估──社会支持" prop="AnswerName15">
              <span style="margin-left:20px">{{ wonedata2.AnswerName31 }}</span>
            </el-form-item> -->

            <!-- <el-form-item disabled="true" label-width="260px" label="保护因素评估──问题解决能力" prop="AnswerName16">
              <span style="margin-left:20px">{{ wonedata2.AnswerName32 }}</span>
            </el-form-item> -->

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──自知力" prop="AnswerName17">
              <span style="margin-left:20px">{{ wonedata2.AnswerName33 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="260px" label="保护因素评估──自制力" prop="AnswerName18">
              <span style="margin-left:20px">{{ wonedata2.AnswerName34 }}</span>
            </el-form-item>

            <!-- <el-form-item disabled="true" label-width="260px" label="保护因素评估──积极的宗教信仰" prop="AnswerName19">
              <span style="margin-left:20px">{{ wonedata2.AnswerName35 }}</span>
            </el-form-item> -->

            <!-- <el-form-item label="保护因素评估──其他相关因素" label-width="260px" prop="AnswerName20" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName36 }}</span>
            </el-form-item> -->


            <el-form-item style="width: 100%;">
              <div class="tit" style="margin-left: 20px;">
                <p>一般精神状态评估</p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" label-width="174px" label="焦虑表现与/或症状" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName38 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName38 == '是'" disabled="true" label-width="190px" label="焦虑表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName38Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="250px" label="注意力缺陷/多动表现与/或症状" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName39 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName39 == '是'" disabled="true" label-width="260px" label="注意力缺陷/多动表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName39Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="234px" label="抑郁/低落心境表现与/或症状" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName40 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName40 == '是'" disabled="true" label-width="250px" label="抑郁/低落心境表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName40Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="212px" label="饮食不规律表现与/或症状" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName41 }}
              </span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName41 == '是'" disabled="true" label-width="240px" label="饮食不规律表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName41Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="232px" label="躁狂/轻度躁狂表现与/或症状" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName42 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName42 == '是'" disabled="true" label-width="250px" label="躁狂/轻度躁狂表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName42Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="198px" label="精神病性表现与/或症状" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName43 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName43 == '是'" disabled="true" label-width="220px" label="精神病性表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName43Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="198px" label="自伤倾向表现与/或症状" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName44 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName44 == '是'" disabled="true" label-width="220px" label="自伤倾向表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName44Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="198px" label="睡眠问题表现与/或症状" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName45 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName45 == '是'" disabled="true" label-width="220px" label="睡眠问题表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName45Detail }}
              </span>
            </el-form-item>

            <el-form-item disabled="true" label-width="212px" label="物质滥用史表现与/或症状" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName46 }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName46 == '是'" disabled="true" label-width="230px" label="物质滥用史表现与/或症状说明" prop="UserID">
              <span style="margin-left:20px">
                {{ wonedata2.AnswerName46Detail }}
              </span>
            </el-form-item>

            <el-form-item label="备注" label-width="80px" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName47 }}</span>
            </el-form-item>

            <el-form-item style="width: 100%;">
              <div class="tit" style="margin-left: 20px;">
                <p>当前状况及社会功能评估</p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" label-width="106px" label="社会功能" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName48 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="106px" label="工作状况" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName49 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="106px" label="家庭支持" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName50 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="106px" label="社会支持" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName51 }}</span>
            </el-form-item>

            <el-form-item label="其他" label-width="80px">
              <span style="margin-left:20px">{{ wonedata2.AnswerName52 }}</span>
            </el-form-item>

            <el-form-item style="width: 100%;">
              <div class="tit" style="margin-left: 20px;">
                <p>来自咨询师的评估印象</p>
              </div>
            </el-form-item>

            <el-form-item label="来访者" label-width="80px" style="width: 100%;">
              <p>
                来访者:
                <span>{{ wonedata.RealName }}</span>
                因
                <span>{{ wonedata2.AnswerName54 }}</span>
                等原因，处于
                <span>{{ wonedata2.AnswerName55 }}</span>
                状态，存在
                <span>{{ wonedata2.AnswerName56 }}</span>
                的情况。
              </p>
            </el-form-item>

            <el-form-item style="width: 100%;">
              <div class="tit" style="margin-left: 20px;">
                <p>咨询记录</p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" label-width="96px" label="咨询主题" style="width: 100%;">
              <span style="margin-left:20px">{{ wonedata2.An61_1Two }}</span>
            </el-form-item>

            <el-form-item style="width: 100%;">
              <div class="tit" style="margin-left: 20px;">
                <p>本次咨询目标与过程概要</p>
              </div>
            </el-form-item>

            <el-form-item label-width="80px" style="width: 100%;">
              <p style="margin-left: 20px;">
                针对来访者:
                <span style="margin-left:20px;margin-left:20px">{{ wonedata2.AnswerName62 }}</span>
                的情况/困扰,经与来访者商讨确定本次咨询的目标为
                <span style="margin-left:20px;margin-left:20px">{{ wonedata2.AnswerName6 }}</span>
              </p>
            </el-form-item>

            <el-form-item disabled="true" label-width="100px" label="采用方法" >
              <span style="margin-left:20px">{{ wonedata2.An64_1Two }}</span>
            </el-form-item>

            <el-form-item v-if="wonedata2.AnswerName64Detail" disabled="true" label-width="140px" label="采用方法说明">
              <span style="margin-left:20px">{{ wonedata2.AnswerName64Detail }}</span>
            </el-form-item>

            <el-form-item label="达成目标" label-width="98px">
              <span style="margin-left:20px">{{ wonedata2.AnswerName65 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="154px" label="是否布置家庭作业">
              <span style="margin-left:20px">{{ wonedata2.AnswerName66 == 1? '否':'是' }}</span>
            </el-form-item>

            <el-form-item style="width: 100%;">
              <div class="tit" style="margin-left: 20px;">
                <p style="font-size: 22px;">
                  改善状况
                  <span style="font-size: 16px; color: rgba(158, 158, 158, 1);">
                    本次咨询结束后，改善状态如何？
                  </span>
                </p>
              </div>
            </el-form-item>

            <el-form-item disabled="true" label-width="74px" label="情绪" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName67 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="74px" label="认知" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName68 }}</span>
            </el-form-item>

            <el-form-item disabled="true" label-width="74px" label="行为" prop="UserID">
              <span style="margin-left:20px">{{ wonedata2.AnswerName69 }}</span>
            </el-form-item>

            <el-form-item style="width: 98%;">
              <div class="tit" style="margin-left: 20px;">
                <p style="font-size: 22px;">咨询过程记录</p>
              </div>
            </el-form-item>

            <el-form-item label-width="80px" style="width: 98%;">
              <span style="margin-left:20px">{{ wonedata2.AnswerName70 }}</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {
      hcsuih: false,
      yn: false,
      UserID: "",
      desc: "",
      dialogVisible: false,
      drawer: false,
      wloadings: false,
      Counts: 0,
      formInline: {
        Synthetical: "",
        Unit: "",
        ConsultPaperTime: [],
        pageIndex: 1,
        pageSize: 10,
      },
      currentPage1: 1,
      tableData: [],
      tableData2: [],
      Birthday: "",
      BirthdayTi: "",
      EmergentMobile: "",
      EmergentPerson: "",
      EmergentRelation: "",
      MarriageState: "",
      Name: "",
      Phone: "",
      Sex: "",
      fromdata: {
        UserID: "",
        AnswerID: "",
        ConsultTeacher: "",
        ApplyReason: "",
        RefuseReason: "",
        ApplyConsultKey:'',
      },
      WPPdialogVisible2: false,
      wonedata: {},
      wonedata2:{},
      from: {
        AnswerName1: "",
        AnswerName2: "",
        AnswerName3: "",
        AnswerName4: "",
        AnswerName5: "",
        AnswerName6: "",
        AnswerName7: "",
        AnswerName8: "",
        AnswerName9: "",
        AnswerName10: "",
        AnswerName11: "",
        AnswerName12: "",
        AnswerName13: "",
        AnswerName13_1: [],
        AnswerName14: "",
        AnswerName15: "",
        AnswerName16: "",
        AnswerName17: "",
        AnswerName18: "",
        AnswerName19: "",
        AnswerName20: "",
        AnswerName21: "",
        AnswerName22: "",
        AnswerName23: "",
        AnswerName24: "",
        AnswerName25: "",
        AnswerName26: "",
        AnswerName27: "",
        AnswerName28: "",
        AnswerName29: "",
        AnswerName30: "",
        AnswerName31: "",
        AnswerName32: "",
        AnswerName33: "",
        AnswerName34: "",
        AnswerName35: "",
        AnswerName35: "",
        AnswerName37: "",
        AnswerName38: "",
        AnswerName39: "",
        AnswerName40: "",
        AnswerName41: "",
        AnswerName42: "",
        AnswerName43: "",
        AnswerName44: "",
        AnswerName45: "",
        AnswerName46: "",
        AnswerName47: "",
        AnswerName48: "",
        AnswerName49: "",
        AnswerName50: "",
        AnswerName51: "",
        AnswerName52: "",
        AnswerName53: "",
        AnswerName54: "",
        AnswerName55: "",
        AnswerName56: "",
        AnswerName57: "",
        AnswerName58: "",
        AnswerName59: "",
        AnswerName60: "",
        AnswerName61: [],
        AnswerName62: "",
        AnswerName63: "",
        AnswerName64: [],
        AppointmentID: "",
        UserID: "",
        Counselor: "",
        Riqi: "",
      },
    };
  },
  methods: {
    handleClose(done) {
      this.$confirm(this.$t('original.languages60')).then((_) => {
        done();
      })
      .catch((_) => {});
    },

    determine(val) {
      this.$Http_Post("ConsultSubscribe/AddVisitorApplyfor", {from: this.fromdata}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.dialogVisible = false;
          this.handleClick(this.fromdata);
          this.Global.request_successful(res.Message)
        } else {
          this.wloadings = false;
        }
      }).catch((err) => {
        this.$message({
          type: "error",
          message: err.message,
        });
      });
    },
    resetForm(formName) {
      this.formInline.Synthetical = '';
      this.formInline.Unit = '';
      this.formInline.ConsultPaperTime = [];
      this.loading(1, 0);
    },
    screening() {
      this.loading(1, 0);
    },
    pdroleid(id) {
      var RoleID = sessionStorage.getItem('RoleID')
      if (RoleID.indexOf(id) !== -1) {
        return true
      } else {
        return false
      }
    },
    Toapply(val) {
      this.fromdata.ApplyConsultKey = val.ApplyConsultKey
      this.dialogVisible = true;
      this.fromdata.AnswerID = val.AnswerID; //咨询预约id
      this.fromdata.ConsultTeacher = val.ZuUserID; //咨询师id
      this.fromdata.ApplyReason = ""; //申请理由
      this.fromdata.RefuseReason = ""; //拒绝理由
    },
    handleClick(res) {
      var AnswerID = res.UserID;
      this.fromdata.UserID = res.UserID;
      var feom = {};
      feom.UserID = AnswerID;
      feom.pageSize = 10;
      feom.pageIndex = 1;
      this.$Http_Post("ConsultSubscribe/GetConsultiveGR", { from: feom })
        .then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Name = res.Data.Name;
            this.Sex = res.Data.Sex;
            this.BirthdayTi = res.Data.BirthdayTi;
            this.Birthday = res.Data.Birthday;
            this.MarriageState = res.Data.MarriageState;
            this.Phone = res.Data.Phone;
            this.EmergentPerson = res.Data.EmergentPerson;
            this.EmergentMobile = res.Data.EmergentMobile;
            this.EmergentRelation = res.Data.EmergentRelation;
            this.tableData2 = res.Data.ltive;
          } else {
            this.wloadings = false;
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message,
          });
        });
      this.drawer = true;
    },
    pdroleid(id) {
      var RoleID = sessionStorage.getItem('RoleID')
      if (RoleID.indexOf(id) !== -1) {
        return true
      } else {
        return false
      }
    },
    handleCheckRecord(obj){
      var xcscs = {
        AppointmentID: obj.AppointmentID,
      };
      this.WPPdialogVisible2 = true;


      this.$Http_Post("ConsultSubscribe/FxConsultAnswer", { from: xcscs }).then((res) => {
        this.$message.closeAll();
        if (res.Code == 200 || res.Code == 0) {
          this.wonedata2 = res.Data;
        }
      });

      var csccvsd = {
        "AppointmentID": obj.AppointmentID,
      }
      this.$Http_Post("ConsultAppoint/GetappointmentDetails", {from: csccvsd}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.wonedata = res.Data;
        }
      });



    },
    show: function (event) {},
    handleCurrentChange(val) {
      this.loading(val, 0);
    },
    mousedown(event) {
      if (event.which === 3) {
      }
    },
    mouseup(event) {
      if (event.which === 3) {
      }
    },
    loading(num, DeriveText) {
      this.formInline.pageIndex = num;
      this.wloadings = true;
      this.$Http_Post("ConsultSubscribe/GetConsultive", {from: this.formInline}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.yn = res.Data.YN;
          this.wloadings = false;
          this.tableData = res.Data.Jihe;
          this.Counts = Number(res.Counts);
        } else {
          this.wloadings = false;
        }
      })
      .catch((err) => {
        this.$message({
          type: "error",
          message: err.message,
        });
      });
    },
  },
  mounted() {
    this.loading(1, 0);
    if(this.Global.pdroleid(1070) || this.Global.pdroleid(1066)){
      this.hcsuih = true
    }else{
      this.hcsuih = false
    }
  },
};
</script>
<style>

.CancelReservations .td_left {
  color: rgba(141, 141, 141, 1);
  font-size: 14px;
  padding: 15px;
}

.CancelReservations .td_right {
  text-align: left;
  font-size: 14px;
  color: rgba(40, 40, 40, 1);
}

.CancelReservations .el-dialog {
  height: auto !important;
}

.CancelReservations .buttons {
  width: 100%;
  text-align: center;
  margin: 20px;
}

.CancelReservations .Statusblue {
  border-radius: 4px;
  padding: 5px 10px;
  background: rgba(29, 154, 255, 0.1);
  color: rgba(29, 154, 255, 1);
}

.CancelReservations .Statusgreen {
  border-radius: 4px;
  background-color: rgba(21, 191, 109, 0.1);
  color: rgba(21, 191, 109, 1);
  padding: 5px 10px;
}

.CancelReservations .Statusred {
  border-radius: 4px;
  background-color: rgba(242, 75, 78, 0.1);
  color: rgba(242, 75, 78, 1);
  padding: 5px 10px;
}

.CancelReservations .Statusgray {
  border-radius: 4px;
  padding: 5px 10px;
  background: rgba(141, 141, 141, 0.1);
  color: rgba(141, 141, 141, 1);
}
.CancelReservations .el-drawer__container h2 {
  padding: 15px;
}
.CancelReservations .el-drawer__container h6 {
  margin-left: 15px;
  font-size: 17px;
}
.CancelReservations .el-drawer__container h5 {
  margin-left: 15px;
  font-size: 17px;
}
.CancelReservations .el-drawer__container ul {
  margin-left: 15px;
  margin-top: 15px;
}
.CancelReservations .el-drawer__container ul li {
  margin-top: 10px;
}
.CancelReservations .el-drawer__container .el-table {
  margin-top: 15px;
}
.CancelReservations .el-drawer__open .el-drawer.rtl {
  width: 40% !important;
}

.CancelReservations .filein {
  background-color: rgba(239.99999999999997,239.99999999999997,239.99999999999997,1);
}
.CancelReservations .filein-top {
  width: 100%;
  background-color: #fff;
}

.CancelReservations .filein-button {
  min-height: 555px;
  margin-top: 20px;
  background-color: #fff;
}

.CancelReservations .filein-button h2 {
  font-size: 24px;
  font-weight: 700;
  padding: 5px 16px;
}

.CancelReservations .filein-button h3 {
  font-size: 18px;
  font-weight: 700;
  padding: 5px 16px;
  padding-left: 24px;
  padding-top: 0px;
}
.CancelReservations .filein-top .filein-top-p1 {
  font-size: 20px;
  font-weight: 700;
  padding: 16px;
}
.CancelReservations .filein-top .filein-top-p2 {
  font-size: 18px;
  padding: 16px;
}
.CancelReservations .filein-top .filein-top-p2 span {
  font-size: 16px;
  color: rgba(141, 141, 141, 1);
}
.CancelReservations .filein-top i {
  display: inline-block;
  background-color: rgba(29, 154, 255, 1);
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  font-weight: 111;
  padding: 1px;
  padding-left: 6px;
  padding-right: 6px;
}
.CancelReservations .filein-top em {
  display: inline-block;
  background-color: rgba(21, 191, 109, 1);
  font-size: 14px;
  height: 26px;
  width: 60px;
  line-height: 26px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  font-weight: 111;
}
.CancelReservations .filein-top .el-button {
  margin-right: 16px;
  position: absolute;
  right: 50px;
  top: 50px;
}

.CancelReservations .el-dialog__body .el-form-item__label {
  background-color: rgba(245, 247, 250, 1);
  text-align: left;
  text-indent: 24px;
  height: 100%;
}

.CancelReservations .el-dialog__body .hiucs {
  width: 680px !important;
}
.CancelReservations .hiucs .el-form-item__label {
  height: 54px !important;
  line-height: 54px;
}

.CancelReservations .el-input {
  width: 200px;
}
.CancelReservations .el-radio {
  margin-left: 0px;
}

.CancelReservations .el-form--inline .el-form-item {
  border: 1px solid rgba(245, 247, 250, 1);
  width: calc(50 - 2px);
  margin-right: 0px;
}
.CancelReservations .el-dialog__body .el-form-item__label {
  background-color: rgba(245, 247, 250, 1);
  text-align: left;
  text-indent: 24px;
  height: 100%;
}

.CancelReservations .el-dialog__body .el-form--inline .el-form-item {
  width: calc(50% - 20px);
}
.CancelReservations .el-dialog__body .hiucs {
  width: 680px !important;
}
.CancelReservations .hiucs .el-form-item__label {
  height: 54px !important;
  line-height: 54px;
}
.CancelReservations .el-dialog__body .el-textarea__inner {
  margin-left: 0px !important;
}
.CancelReservations .qxs1 .el-input__inner {
  border: none;
  border-bottom: 1px solid rgb(182, 182, 182);
  border-radius: 0px;
}
.CancelReservations .bagtit .el-form-item {
  border: none !important;
}
.CancelReservations .el-dialog__body .bvds {
  width: calc(50% - 40px) !important;
}
.CancelReservations .hiucs2 .el-form-item__label {
  height: 106px !important;
  line-height: 106px;
}
.CancelReservations .el-dialog__body .svccsc {
  width: 840px !important;
}
.CancelReservations .svccsc .el-form-item__label {
  height: 54px !important;
  line-height: 54px;
}
.CancelReservations .el-dialog__body .svcsscsc {
  width: 860px !important;
}
.CancelReservations .svcsscsc .el-form-item__label {
  height: 54px !important;
  line-height: 54px;
}
.CancelReservations .el-dialog__body .el-form-item__content span {
  margin-left: 5px;
}
.CancelReservations .boxs {
  background-color: #fff;
  margin-bottom: 15px;
}
.CancelReservations .boxs button {
  float: right;
  margin-right: 20px;
}
.CancelReservations .boxs2 {
  background-color: #fff;
  height: 620px;
}
.CancelReservations .block {
  float: right;
}
.CancelReservations .el-drawer__body tbody td {
  border: none;
}
.CancelReservations .el-descriptions-item__label {
  color: rgba(40, 40, 40, 1);
  font-size: 16px;
}
.CancelReservations .el-descriptions-item__content {
  color: rgba(141, 141, 141, 1);
}
.CancelReservations .el-drawer__open .el-drawer.rtl {
  width: 40% !important;
}
</style>
